import React from 'react';
import { Helmet } from 'react-helmet-async';
import SmartNavbar from './SmartNavbar';

const Header: React.FC = () => {
  return (
    <>
      {/*
        NOTE: Title and description are NOT set here.
        Each page should use SEOHelmet to set page-specific title, description, and canonical URL.
        Only global meta tags that apply to all pages are set here.
      */}
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#0A261D" />
        <link rel="icon" href="/favicon.ico" />
        <link rel="apple-touch-icon" href="/logo192.png" />
        {/* <link rel="manifest" href="/manifest.json" /> */}
      </Helmet>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-antique-gold focus:text-forest-darkest focus:rounded focus:outline-none focus:ring-2 focus:ring-forest-deep"
      >
        Skip to main content
      </a>
      <header>
        <SmartNavbar />
      </header>
    </>
  );
};

export default Header;